export default __webpack_public_path__ + "static/media/group-figure.81588deb.jpg";